import { useMemo } from "react";

// import icons
import hhIcon from "../Assets/Icons/hh.png";
import esIcon from "../Assets/Icons/es.png";
import csIcon from "../Assets/Icons/cs.png";

export const Services = () => {
    const servicesArr = useMemo(() => {
        return [
            {
                icon: hhIcon,
                title: "Head Hunting",
                list: [
                    "Direct Outreach",
                    "Talent Mapping",
                    "Networking & Social Media",
                    "Technology & Referrals",
                    "Discreet  Engagement & Branding"
                ],
            },
            {
                icon: esIcon,
                title: "Executive Searches",
                list: [
                    "Databases & Talent Mapping",
                    "Direct Headhunting & Confidential Outreach",
                    "Networking & Professional Events",
                    "Social Media & Branding",
                    "Global Search & Succession Planning"
                ],
            },
            {
                icon: csIcon,
                title: "Candidate Services",
                list: [
                    "Professional Cv write up",
                    "Interview Presentation Masterclass"
                ],
            }
        ];
    }, []);

    return (
        <div className="services-cards">
            {servicesArr.map((serv, index) => (
                <div key={index} className="service-card">
                    <div className="bg" />
                    <div className="card-wrap">
                        <div className="icon">
                            <img src={serv.icon} alt="icon" />
                        </div>
                        <h2>{serv.title}</h2>
                        <div className="line" />
                        <ul>
                            {serv.list.map((li, index) => (
                                <li key={index}>{li}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    );
}